import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/page-group';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: false,
  groupId: null,
  socialListingIds: [],
  socialMoreCount: 0,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {groupId}) => {
    return {...state,
      loadPending: true,
      groupId,
      socialListingIds: [],
      socialMoreCount: 0,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {groupId, result}) => {
    if (groupId !== state.groupId) return state;
    return {...state,
      loadPending: false,
      socialListingIds: result[2].socialPostListings.map(l => l.id),
      socialMoreCount: result[2].socialMoreCount,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, {groupId}) => {
    if (groupId !== state.groupId) return state;
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
